import { Redirect, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Box, Grid, makeStyles } from '@material-ui/core'
import { useState } from 'react'

import useUser from 'user-module/user/core/useUser'
import CheckoutIcon from 'spypoint/src/assets/icons/CheckoutPageIcon'
import AppBarContainer from 'shared-module/components/app-bar/AppBarContainer'
import CheckoutComponent from './CheckoutComponent'
import { useECommerceFlag } from 'spypoint/src/ecommerce-module/hooks/UseEcommerceFlag'
import useQueryParams from 'shared-module/url/useQueryParams'
import RouteLeavingGuard from 'shared-module/RouteLeavingGuard'
import { useCart } from 'spypoint/src/checkout-module/order/core/cart.hooks'

const useStyles = makeStyles({
  root: {
    marginTop: '150px',
    overflow: 'hidden',
  },
  grid: {
    padding: '0 2rem',
  },
})

const CheckoutPage = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const user = useUser()
  const history = useHistory()
  const eCommerceEnabled = useECommerceFlag()
  const { deleteFromCart, cartItems } = useCart()
  const queryParams = useQueryParams()
  const [completeCheckout, setCompleteCheckout] = useState(false)
  const leaveGuard = queryParams.checkout === 'stripe' && eCommerceEnabled
  const hideForStripeCheckout = queryParams.checkout === 'stripe'
  const leaveGuardTexts = {
    title: t('app:checkout_process.photo_transmission_plan.leave_guard_title'),
    content: t('app:checkout_process.photo_transmission_plan.leave_guard'),
  }

  if (eCommerceEnabled && queryParams.checkout !== 'stripe') {
    history.push('/')
  }
  const handleConfirmNavigationClick = () => {
    deleteFromCart({ itemId: cartItems?.products[0].id })
  }

  return user.cartEnabled
    ? (
      <Box className={classes.root}>
        <Grid container direction="row" justifyContent="center" alignItems="flex-start" spacing={3} className={classes.grid}>
          { leaveGuard && !!leaveGuardTexts && (
            <RouteLeavingGuard
              when={!completeCheckout}
              title={leaveGuardTexts.title}
              message={leaveGuardTexts.content}
              isNewUi
              action={handleConfirmNavigationClick}
            />
          ) }
          <AppBarContainer Icon={CheckoutIcon} title={t('menu.checkout_menu')} />
          <CheckoutComponent eCommerceEnabled={eCommerceEnabled} setCompleteCheckout={setCompleteCheckout} hideForStripeCheckout={hideForStripeCheckout} />
        </Grid>
      </Box>
      )
    : <Redirect to="/" />
}

export default CheckoutPage
